export enum MediaException {
    notFound = 'NotFoundError',
    security = 'SecurityError',
    notAllowed = 'NotAllowedError',
    abort = 'AbortError',
    notReadable = 'NotReadableError',
}
